@import "../use-bootstrap-mixins.scss";

.disabledContainer {
  opacity: 0.5;
  pointer-events: none;
}

span.header_text {
  color: $primaryOnBackground !important;
  margin: 0 !important;
  font-size: calc(1.3rem + 0.6vw);
  font-weight: 600 !important;
}

.container {
  max-width: 1200px;
  background-color: #f5f5f5;
  margin: 0 auto;
  border-radius: 12px;
  padding: 10px;

  @include media-breakpoint-up(md) {
    padding: 20px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    background-color: $primary;
    padding: 20px 24px;
    border-radius: 8px;

    margin-bottom: 12px;

    @include media-breakpoint-down(lg) {
      display: none;
    }

    div {
      flex: 1;
    }

    button {
      width: 166px !important;
    }

    .title {
      display: block;
      font-size: 20px;
      text-align: center !important;
      color: $textColorOnPrimary !important;
      font-weight: 700 !important;

      @include media-breakpoint-down(lg) {
        display: none;
      }
    }
  }

  .fold {
    width: 100%;
    margin: 30px 0px;
    border-bottom: 2px dashed #333;
  }

  .terms_and_conditions {
    margin-top: 20px;
    background-color: #fff;
    padding: 12px;
    border: 1px solid #d0d0d0;
    border-radius: 4px;
    max-height: 150px;
    overflow-y: scroll;
    white-space: pre-wrap;
    p {
      font-size: 14px;
      margin: 0;
    }
    a {
      color: #337ab7 !important;
    }
  }

  .dangerous_goods_warning {
    margin-top: 1rem;
    text-align: center;

    img {
      width: 100%;
      max-width: fit-content;
    }
  }

  .opt_in_container {
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    gap: 8px;

    @include media-breakpoint-up(lg) {
      gap: 12px;
      flex-direction: row;
    }

    .opt_in {
      display: flex;
      gap: 6px;
      align-items: center;

      .custom_checkbox {
        position: relative;
        width: 21px;
        height: 21px;

        label {
          background-color: #fff;
          width: 21px;
          height: 21px;
          border-radius: 11px;
          cursor: pointer;
          position: absolute;
          border: 1px solid #ccc;

          &:after {
            display: initial !important;
            border: 2px solid #fff;
            border-top: none;
            border-right: none;
            content: "";
            height: 6px;
            left: 4px;
            opacity: 0;
            position: absolute;
            top: 6px;
            transform: rotate(-45deg);
            width: 11px;
          }
        }

        input[type="checkbox"] {
          display: none;

          &:checked + label {
            background-color: $primaryOnBackground;
            border-color: $primaryOnBackground;

            &:after {
              opacity: 1;
            }
          }
        }
      }
    }
  }

  .moveInError {
    font-size: 14px !important;
    color: #d04d52 !important;
    background-color: #faeded;
    border: 1px solid #d04d52;
    padding: 12px 12px;
    border-radius: 4px;
    display: block;
    margin-bottom: 12px;
    font-weight: 500 !important;
    display: flex;
    gap: 12px;

    svg {
      max-width: 20px;
    }
  }

  .confirm_booking {
    max-width: 200px;
    margin-top: 24px;
  }

  .booking_confirmation {
    .title {
      display: flex;
      align-items: center;
      gap: 12px;
      justify-content: center;
      margin-bottom: 24px;

      .thumbs_up {
        width: 48px;
        stroke: $primary;

        @include media-breakpoint-up(lg) {
          width: 64px;
        }
      }

      span {
        font-size: 22px !important;
        font-weight: bold !important;
        color: $primary !important;

        @include media-breakpoint-up(lg) {
          font-size: 36px !important;
        }
      }
    }

    .subtitle {
      font-weight: 500 !important;
      margin: 0;
    }

    .pleaseWait {
      font-weight: 900 !important;
      margin: 0;
    }

    .referenceCode {
      display: flex;
      gap: 8px;
      margin-top: 12px;

      &:hover {
        cursor: pointer;
      }

      .text {
        font-weight: bold !important;
      }

      .code {
        font-weight: 500 !important;
        color: #666 !important;
      }

      svg {
        width: 24px;
        stroke-width: 2;
      }
    }

    .id_verify_section {
      display: flex;
      justify-content: center;
      flex-direction: column;

      button {
        width: 100%;
        @include media-breakpoint-up(md) {
          max-width: 200px;
        }
      }
    }
  }

  .customer_survey {
    .app_download_text {
      display: block;
      text-align: center;
    }

    .store_images {
      display: flex;
      gap: 8px;
      margin-bottom: 12px;
      justify-content: center;

      img {
        max-height: 40px;

        &:hover {
          cursor: pointer;
        }

        @include media-breakpoint-up(lg) {
          max-height: 60px;
        }
      }
    }

    .title {
      font-size: 22px !important;
      font-weight: bold !important;
      color: $primary !important;
      margin: 0;

      @include media-breakpoint-up(lg) {
        font-size: 36px !important;
      }
    }
  }
}
